// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/checbox-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/file-download.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/user-menu-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28218, 13, 41, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 1%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table.flotas td {
  font-weight: 700;
  vertical-align: middle;
}

.flotas-btn button img {
  opacity: 0.7;
  transition: all 0.2s linear;
}

.flotas-btn button img:hover,
.flotas-btn button img:active {
  opacity: 1;
  transition: all 0.2s linear;
}

.flotas-table-select {
  display: inline;
  vertical-align: super;
}

.flotas-table-select > input[type="checkbox"] {
  padding: 0.5em;
  margin: 0em 2em;
  cursor: pointer;
}

.flotas-table-select > input[type="checkbox"]:checked::after,
.flotas-table-select > .form-check-input:checked[type="checkbox"] {
  color: #db0b27;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 60% 60%; /* Adjust as needed */
  background-color: #fff;
}

.flotas-table .dropdown-toggle::after,
.flotas-saldo .dropdown-toggle::after {
  content: "" !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background-size: 1em;
  background-repeat: no-repeat;
  background-position: center;
  width: 1.2em;
  height: 1.2em;
  margin-left: 0.5em;
  font-size: 0.8em;
  animation: rotate-up 0.3s ease-in-out;
  transform: scaleY(1);
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  right: 1em;
  top: 2.2em;
}

.flotas-btn-add {
  font-size: 0.9em;
}

.flotas-selection {
  display: block;
  width: 100%;
}

.flotas-selection-div {
  display: inline-block;
  width: -moz-fit-content;
  width: fit-content;
  padding: 1.3em 1em;
  border-radius: 0.375rem;
  background-color: #ececec;
  border: none;
  color: #2b363b;
  font-weight: 700;
  margin-right: 0.48em;
  cursor: not-allowed;
  text-transform: capitalize;
}

.flotas-selection .dropdown-toggle,
.flotas-saldo .dropdown-toggle {
  background-color: #ececec;
  border: none;
  color: #2b363b;
  font-weight: 700;
  padding-bottom: 0.9em;
  padding-top: 0.9em;
  text-transform: capitalize;
  width: 100%;
  text-align: left;
}

.flotas-selection .dropdown-toggle::after,
.flotas-saldo .dropdown-toggle::after {
  content: "" !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  background-size: 1em;
  background-repeat: no-repeat;
  background-position: center;
  width: 1.2em;
  height: 1.2em;
  margin-left: 0.5em;
  font-size: 0.8em;
  animation: rotate-up 0.3s ease-in-out;
  transform: scaleY(1);
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  right: 1em;
  top: 2.2em;
}

.flotas-selection .dropdown-toggle.show::after,
.flotas-saldo .dropdown-toggle.show::after {
  transform: scaleY(-1);
  animation: rotate-down 0.3s ease-in-out;
}

@keyframes rotate-down {
  0% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(-1);
  }
}

@keyframes rotate-up {
  0% {
    transform: scaleY(-1);
  }
  100% {
    transform: scaleY(1);
  }
}

.flotas-selection .dropdown-toggle::before,
.flotas-saldo .dropdown-toggle::before {
  content: "";
  font-size: 1.3em;
  margin-right: 0.2em;
}

.flotas-selection .dropdown-toggle::before,
.flotas-selection-div::before {
  content: "" !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 1.4em;
  background-repeat: no-repeat;
  background-position: center;
  width: 2em;
  height: 2em;
  display: inline-block;
  vertical-align: middle;
}

.flotas-selection.show > .btn-primary.dropdown-toggle,
.flotas-saldo.show > .btn-primary.dropdown-toggle,
.btn-primary.dropdown-toggle:active:focus {
  background-color: #ececec;
  border: none;
  color: #2b363b;
  box-shadow: none;
}

.flotas-saldo.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: none;
}

.flotas-actions {
  margin-top: 0em;
}

.flotas-actions .dropdown {
  /* margin-right: 0; */
  width: -moz-fit-content;
  width: fit-content;
}

.flotas-selection-item {
  text-transform: capitalize;
}

.flotas-buttons {
  display: flex;
  flex-direction: row-reverse;
}

.flotas-buttons .btn-check:checked + .btn-outline-danger {
  background-color: #db0b27;
  border-color: #db0b27;
  transition: all 0.3s 0.1s ease-in-out;
}

.flotas-btn-km label {
  border-radius: 3em;
  font-size: 0.7em;
  font-weight: 700;
  line-height: 1em;
  max-width: 5em;
}

.flotas-btn-km.btn-group > .btn:nth-child(n + 3),
.flotas-btn-km.btn-group > :not(.btn-check) + .btn,
.flotas-btn-km.btn-group > .btn-group:not(:first-child) > .btn,
.flotas-btn-km.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.flotas-btn-km.btn-group > .btn-group:not(:last-child) > .btn {
  border: none;
  border-radius: 3em;
}

.flotas-btn-km.btn-group {
  background-color: #ececec;
  border-radius: 3em;
  transition: all 0.3s 0.1s ease-in-out;
}

.btn-check:checked + .btn-outline-danger:focus {
  box-shadow: none;
}

#notifications-icon-check img.flotas-btn-notification-white {
  filter: invert(42%) saturate(2%) brightness(200%) contrast(200%);
}

.alert-danger-form {
  color: #db0b27;
  background-color: #f2dede;
  border-color: #ebccd1;
  font-size: 0.9em;
}

.flotas-btn-error {
  border: #db0b27;
  border-width: 3px;
  border-style: solid;
}

.filter-primary {
  filter: brightness(0) saturate(100%) invert(13%) sepia(98%) saturate(4979%)
    hue-rotate(346deg) brightness(87%) contrast(100%);
}

.alert-promocion {
  background-color: #8bf1b6;
  border-color: #8bf1b6;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 1em;
  text-align: center;
  width: 80%;
}

.alert-incidencia {
  color: #842029;
  background-color: #f8d7da;
  border-color: #f5c2c7;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 1em;
  text-align: center;
  width: 80%;
}

.alert-repostaje {
  color: #055160;
  background-color: #cff4fc;
  border-color: #b6effb;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 1em;
  text-align: center;
  width: 80%;
}

.alert-credito {
  color: #084298;
  background-color: #cfe2ff;
  border-color: #b6d4fe;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 1em;
  text-align: center;
  width: 80%;
}

.alert-antifraude {
  color: #664d03;
  background-color: #fff3cd;
  border-color: #ffecb5;
  min-width: -moz-fit-content;
  min-width: fit-content;
  padding: 1em;
  text-align: center;
  width: 80%;
}

.flotas-selection > .dropdown-menu {
  background-color: #ececec;
  border: none;
  text-align: left;
  width: 100%;
  top: 90% !important;
}

.flotas-selection > .dropdown-menu a {
  font-weight: 700;
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.no-flota {
  text-align: center;
}

.no-flota h2 {
  margin-top: 5vh;
}

#buscadorFlotas::placeholder {
  color: #2b363b80;
  font-weight: 600;
}

#buscadorFlotas {
  padding: 0 1em;
}

#switch-km {
  border-radius: 2em;
  font-size: 1em;
}

#switch-km:hover {
  cursor: pointer;
}

div.switch-km.form-check.form-switch
  > .form-check-input[type="checkbox"]:checked {
  background-color: #db0b27;
}

.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.form-switch .form-check-input:checked {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.flotas-registro-nueva .btn-flota-registro-tipo.btn-lg {
  background-color: #ececec;
  border: none;
  border-radius: 17px;
  box-shadow: 3px 4px 10px rgb(0 0 0 / 30%);
  color: #2b363b;
  font-size: 1.6em;
  font-weight: 700;
  margin-bottom: 2vh;
  padding: 2.5em 2em;
  width: 100%;
}

h1.flotas-registro {
  font-size: 1.4em;
  font-weight: 700;
}

h1.flotas-registro.centered {
  text-align: center;
}

.btn-primary:disabled,
.btn-primary.disabled {
  background-color: transparent;
  border-color: #2b363b40;
  color: #2b363b40;
}

.flotas-registro-buttons {
  display: inline-flex;
  justify-content: space-between;
}

.flotas-registro-buttons button {
  margin: 0 0.3em;
  width: inherit;
}

input.flotas-input {
  font-size: 1.7em;
  font-weight: 700;
  min-height: 2em;
  padding: 0;
  text-align: center;
}

input.flotas-input:focus {
  background-color: #ececec;
  min-height: 2em;
  padding: 0;
}

p.flotas-registro-moneda {
  font-size: 1.4em;
  margin-top: 1.4em;
  text-align: center;
}

.flotas-pref-tel > .dropdown-toggle::after {
  content: "" !important;
  font-size: 1em;
  transform: rotate(180deg);
}

.btn-flotas-tel {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  line-height: 1.25;
  padding: 1rem 0.75rem;
}

.flotas-pref-tel.flotas-pref-tel-ES > .dropdown-toggle::before {
  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/es.svg);
  background-size: 1.5em 1.5em;
  display: inline-block;
  background-repeat: no-repeat;
  width: 2em;
  height: 1.5em;
  content: "";
  vertical-align: bottom;
}

.flotas-pref-tel.flotas-pref-tel-PT > .dropdown-toggle::before {
  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/pt.svg);
  background-size: 1.5em 1.5em;
  display: inline-block;
  background-repeat: no-repeat;
  width: 2em;
  height: 1.5em;
  content: "";
  vertical-align: bottom;
}

.flotas-pref-tel.flotas-pref-tel-AR > .dropdown-toggle::before {
  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/ar.svg);
  background-size: 1.5em 1.5em;
  display: inline-block;
  background-repeat: no-repeat;
  width: 2em;
  height: 1.5em;
  content: "";
  vertical-align: bottom;
}

.flotas-pref-tel.flotas-pref-tel-MX > .dropdown-toggle::before {
  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/mx.svg);
  background-size: 1.5em 1.5em;
  display: inline-block;
  background-repeat: no-repeat;
  width: 2em;
  height: 1.5em;
  content: "";
  vertical-align: bottom;
}

.flotas-pref-tel > .dropdown-menu.show {
  border: 2px solid #f5c2c7;
  border-radius: 0.8em;
  margin-bottom: 0.7em;
  padding: 1em;
  width: 14em;
}

.flotas-pref-tel > .dropdown-menu.show > a {
  font-size: 1.1em;
  font-weight: 600;
  padding: 0.4em 1.5em 0.4em 0.3em;
}

.flotas-pref-tel > .dropdown-menu.show > a > img {
  height: 1.8em !important;
  margin-right: 1em;
  width: 1.8em !important;
}

.back-btn-tarjeta {
  margin-left: 10%;
  width: 83%;
}

.flotas-warning-icon,
.flotas-pdf-icon,
.flotas-study-icon {
  border-radius: 10px;
  display: block;
  height: 80px;
  padding: 1.5em 1em;
  text-align: center;
  width: 80px;
}

.flotas-warning-icon {
  background-color: #ececec;
}

.flotas-pdf-icon {
  background-color: #db0b27;
}

.flotas-study-icon {
  padding: 0.5em;
}

.flotas-model-download {
  align-items: center;
  display: flex;
}

.flotas-model-download p {
  margin-left: 0.8em;
}

.flotas-status-process {
  color: #ffc107;
  font-weight: 700;
}

.flotas-status {
  align-items: center;
  display: flex;
}

.flotas-status img {
  max-width: 60px;
}

.flotas-study {
  max-width: 25em;
  text-align: center;
  margin: 0 auto;
}

h3.flotas-study {
  font-weight: 700;
}

p.flotas-study {
  color: #2b363b80;
  font-weight: 400;
}

#upload-document {
  opacity: 0;
  position: absolute;
  width: 20%;
  z-index: -1;
}

.flotas-document-btn {
  display: flex;
  justify-content: space-evenly;
}

.modal-80w {
  max-width: 80vw;
}

.row-no-padding {
  padding: 0;
  margin-left: 0;
}

.flotas-info-tipo-cuenta {
  font-size: 1.2em !important;
  font-weight: 900 !important;
  display: block;
  text-transform: capitalize;
}

.flotas-info-tags {
  display: flex;
  overflow-x: scroll;
  width: max-content;
}

.flotas-info-tags > .alert.alert-danger {
  text-align: left;
  max-width: 15em;
  min-width: 8.2em;
  padding: 0.3em 2em 0.3em 1em;
  background-color: #ececec;
  border: none;
  color: #2b363b;
  margin-right: 0.6em;
  max-height: 4.1em;
  margin-bottom: 0;
}

.flotas-info-tag-title {
  display: block;
  font-size: 1em !important;
  font-weight: 700 !important;
  margin-bottom: -0.5em;
  color: #2b363bbf;
}

.flotas-info-tag-number {
  font-size: 1.3em !important;
  font-weight: 900 !important;
}

.flota-bloqueada {
  max-width: 35em;
  text-align: left;
  display: inline-flex;
  vertical-align: middle;
  font-weight: 700;
  font-size: 0.8em;
  background: #da0d2926;
  padding: 0.6em 1em;
  border-radius: 0.5em;
  color: #da0d29;
  margin-top: 1em;
}

.flota-bloqueada-icon {
  margin-right: 2em;
  width: 30px;
  height: 31px;
}

.thin {
  font-weight: 300 !important;
}

.btn-icon-font {
  color: #606676;
}

.btn-icon-font:hover {
  color: #1d253c;
}

.flotas-actions-btn-trash {
  font-size: 0.9em;
}

.btn-outline-grey .flotas-actions-btn-trash {
  background-color: transparent;
  border-color: #2b363b40;
  color: #2b363b40;
}

.btn-outline-file {
  background-color: transparent;
  border-color: #2b363b40;
  color: #2b363b40;
}

.btn-outline-file:disabled,
.btn-outline-file.disabled {
  background-color: transparent;
  border-color: #2b363b40;
  color: #2b363b;
  font-weight: 600;
  font-size: 0.9em;
  text-align: left;
  padding-left: 1em;
}

.btn-outline-primary-file,
.outline-primary-file {
  background-color: transparent;
  border: none;
  padding-left: 0.5em;
  text-align: left;
  display: flex;
  align-items: end;
  color: #db0b27;
  font-weight: 600;
}

.btn-outline-primary-file:hover,
.outline-primary-file:hover {
  background-color: #eaeaea;
  border: none;
  color: #db0b27;
}

.form-label.flotas-form-label {
  font-weight: 700;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
  font-size: 0.85em;
}

.input-radio-flotas {
  display: flex;
  flex-direction: row;
  align-items: end;
  gap: 0.8em;
  margin-left: 2em;
}

.input-radio-flotas > .form-check-input {
  border-radius: 50%;
  border-width: 1px;
  border-color: #2b363b40;
}

.input-radio-flotas > .form-check-input:checked {
  border-color: #db0b27;
  background-image: radial-gradient(
    circle at center,
    #db0b27 60%,
    transparent 61%
  );
  background-repeat: no-repeat;
  background-position: center;
  background-size: 75% 75%;
  background-color: #fff;
  font-size: 1em;
  line-height: 1em;
}

.input-radio-flotas > .form-check-input:checked:after {
  content: "" !important;
}

.input-radio-flotas > .form-check-input:checked + label {
  color: #db0b27;
  font-weight: 600;
}

/* BREAKPOINT TABLETS*/
@media (min-width: 768px) {
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  /* General Styles */
  .flotas-register-btn {
    width: -moz-fit-content;
    width: fit-content;
    margin: 0 auto;
    padding-left: 2em;
    padding-right: 2em;
  }

  .flotas-btn-step1 {
    display: flex;
  }

  .flotas-registro-nueva .btn-flota-registro-tipo.btn-lg {
    margin: 0 0.5em;
  }

  .flotas-registro-cantidad {
    display: flex;
    justify-content: space-evenly;
    margin: 0 auto;
    width: 60%;
  }

  .flotas-registro-cantidad input.flotas-input {
    width: 40%;
  }

  .flotas-status {
    margin: 0 auto;
    text-align: center;
  }

  .flotas-image-info {
    width: 60%;
    margin: 0 auto;
  }

  .flotas-document-btn {
    display: block;
    font-size: 1em;
  }

  label.flotas-document-btn {
    padding-top: 0.8em;
  }

  .no-flota {
    margin-top: -5em;
  }

  .back-btn-tarjeta {
    width: 25%;
  }

  .flotas-model-download {
    flex-direction: column;
    text-align: center;
  }

  .flotas-pdf-icon {
    width: 60px;
    height: 60px;
    padding: 0.8em;
  }

  .flotas-info-tags {
    display: inline-flex !important;
    width: -moz-fit-content;
    width: fit-content;
    overflow: hidden;
  }

  .flotas-info {
    position: absolute;
    top: 0;
    width: -moz-fit-content;
    width: fit-content;
  }

  .flota-bloqueada {
    margin: 0 1em;
  }

  .flota-bloqueada-icon {
    margin-right: 1em;
  }

  .flotas-selection {
    display: inline;
  }

  .flotas-selection .dropdown-toggle::after,
  .flotas-saldo .dropdown-toggle::after {
    position: inherit;
  }

  .flotas-selection .dropdown-toggle,
  .flotas-saldo .dropdown-toggle {
    width: -moz-fit-content;
    width: fit-content;
    text-align: center;
  }

  .flotas-selection > .dropdown-menu {
    text-align: center;
    width: 100%;
    top: -20% !important;
    max-height: 200px;
    overflow-y: auto;
  }

  /* .flotas-info-tags > .alert.alert-danger {
    max-width: 10em;
  } */

  .flotas-info-tag-title {
    display: block;
    font-size: 0.7em !important;
    font-weight: 700 !important;
    margin-bottom: inherit;
  }

  .flotas-info-tag-number {
    font-size: 1em !important;
    font-weight: 900 !important;
  }

  .flotas-info-tipo-cuenta {
    margin-top: inherit;
  }

  table.flotas thead {
    border-bottom: 1px solid #dbdbdb;
  }

  table.flotas tr,
  table.flotas td {
    border-bottom: none;
  }
  table.flotas th,
  table.flotas th:last-child,
  table.flotas td {
    text-align: left;
  }

  table.flotas th,
  table.flotas td {
    display: table-cell !important;
  }

  .no-pointer {
    cursor: not-allowed;
    pointer-events: none;
  }

  .flotas-btn-add {
    max-width: 94%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/flotas/flotas.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,iEAAqE;EACrE,wBAAwB,EAAE,qBAAqB;EAC/C,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,oEAAyE;EACzE,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,oEAA0E;EAC1E,oBAAoB;EACpB,4BAA4B;EAC5B,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,yDAA+pF;EAC/pF,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;EAGE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;EAKE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;qDACmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,2BAAsB;EAAtB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,4DAA+L;AACjM;;AAEA;EACE,4DAA8L;AAChM;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kGAAkG;EAClG,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,UAAU;EACV,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kGAAkG;EAClG,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,UAAU;EACV,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kGAAkG;EAClG,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,UAAU;EACV,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kGAAkG;EAClG,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,UAAU;EACV,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;EAC7B,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB;;;;GAIC;EACD,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;AACA;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB;IACE,uBAAkB;IAAlB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,+BAA+B;IAC/B,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;KAEG;;EAEH;IACE,cAAc;IACd,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,mBAAmB;EACrB;EACA;;;IAGE,gBAAgB;EAClB;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["table.flotas td {\n  font-weight: 700;\n  vertical-align: middle;\n}\n\n.flotas-btn button img {\n  opacity: 0.7;\n  transition: all 0.2s linear;\n}\n\n.flotas-btn button img:hover,\n.flotas-btn button img:active {\n  opacity: 1;\n  transition: all 0.2s linear;\n}\n\n.flotas-table-select {\n  display: inline;\n  vertical-align: super;\n}\n\n.flotas-table-select > input[type=\"checkbox\"] {\n  padding: 0.5em;\n  margin: 0em 2em;\n  cursor: pointer;\n}\n\n.flotas-table-select > input[type=\"checkbox\"]:checked::after,\n.flotas-table-select > .form-check-input:checked[type=\"checkbox\"] {\n  color: #db0b27;\n  --bs-form-check-bg-image: url(\"../../assets/images/checbox-icon.svg\");\n  background-size: 60% 60%; /* Adjust as needed */\n  background-color: #fff;\n}\n\n.flotas-table .dropdown-toggle::after,\n.flotas-saldo .dropdown-toggle::after {\n  content: \"\" !important;\n  background-image: url(\"../../assets/images/file-download.svg\") !important;\n  background-size: 1em;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 1.2em;\n  height: 1.2em;\n  margin-left: 0.5em;\n  font-size: 0.8em;\n  animation: rotate-up 0.3s ease-in-out;\n  transform: scaleY(1);\n  display: inline-block;\n  vertical-align: middle;\n  position: absolute;\n  right: 1em;\n  top: 2.2em;\n}\n\n.flotas-btn-add {\n  font-size: 0.9em;\n}\n\n.flotas-selection {\n  display: block;\n  width: 100%;\n}\n\n.flotas-selection-div {\n  display: inline-block;\n  width: fit-content;\n  padding: 1.3em 1em;\n  border-radius: 0.375rem;\n  background-color: #ececec;\n  border: none;\n  color: #2b363b;\n  font-weight: 700;\n  margin-right: 0.48em;\n  cursor: not-allowed;\n  text-transform: capitalize;\n}\n\n.flotas-selection .dropdown-toggle,\n.flotas-saldo .dropdown-toggle {\n  background-color: #ececec;\n  border: none;\n  color: #2b363b;\n  font-weight: 700;\n  padding-bottom: 0.9em;\n  padding-top: 0.9em;\n  text-transform: capitalize;\n  width: 100%;\n  text-align: left;\n}\n\n.flotas-selection .dropdown-toggle::after,\n.flotas-saldo .dropdown-toggle::after {\n  content: \"\" !important;\n  background-image: url(\"../../assets/images/user-menu-icon.svg\") !important;\n  background-size: 1em;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 1.2em;\n  height: 1.2em;\n  margin-left: 0.5em;\n  font-size: 0.8em;\n  animation: rotate-up 0.3s ease-in-out;\n  transform: scaleY(1);\n  display: inline-block;\n  vertical-align: middle;\n  position: absolute;\n  right: 1em;\n  top: 2.2em;\n}\n\n.flotas-selection .dropdown-toggle.show::after,\n.flotas-saldo .dropdown-toggle.show::after {\n  transform: scaleY(-1);\n  animation: rotate-down 0.3s ease-in-out;\n}\n\n@keyframes rotate-down {\n  0% {\n    transform: scaleY(1);\n  }\n  100% {\n    transform: scaleY(-1);\n  }\n}\n\n@keyframes rotate-up {\n  0% {\n    transform: scaleY(-1);\n  }\n  100% {\n    transform: scaleY(1);\n  }\n}\n\n.flotas-selection .dropdown-toggle::before,\n.flotas-saldo .dropdown-toggle::before {\n  content: \"\";\n  font-size: 1.3em;\n  margin-right: 0.2em;\n}\n\n.flotas-selection .dropdown-toggle::before,\n.flotas-selection-div::before {\n  content: \"\" !important;\n  background-image: url(\"data:image/svg+xml;base64,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\");\n  background-size: 1.4em;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 2em;\n  height: 2em;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.flotas-selection.show > .btn-primary.dropdown-toggle,\n.flotas-saldo.show > .btn-primary.dropdown-toggle,\n.btn-primary.dropdown-toggle:active:focus {\n  background-color: #ececec;\n  border: none;\n  color: #2b363b;\n  box-shadow: none;\n}\n\n.flotas-saldo.show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: none;\n}\n\n.flotas-actions {\n  margin-top: 0em;\n}\n\n.flotas-actions .dropdown {\n  /* margin-right: 0; */\n  width: fit-content;\n}\n\n.flotas-selection-item {\n  text-transform: capitalize;\n}\n\n.flotas-buttons {\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.flotas-buttons .btn-check:checked + .btn-outline-danger {\n  background-color: #db0b27;\n  border-color: #db0b27;\n  transition: all 0.3s 0.1s ease-in-out;\n}\n\n.flotas-btn-km label {\n  border-radius: 3em;\n  font-size: 0.7em;\n  font-weight: 700;\n  line-height: 1em;\n  max-width: 5em;\n}\n\n.flotas-btn-km.btn-group > .btn:nth-child(n + 3),\n.flotas-btn-km.btn-group > :not(.btn-check) + .btn,\n.flotas-btn-km.btn-group > .btn-group:not(:first-child) > .btn,\n.flotas-btn-km.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.flotas-btn-km.btn-group > .btn-group:not(:last-child) > .btn {\n  border: none;\n  border-radius: 3em;\n}\n\n.flotas-btn-km.btn-group {\n  background-color: #ececec;\n  border-radius: 3em;\n  transition: all 0.3s 0.1s ease-in-out;\n}\n\n.btn-check:checked + .btn-outline-danger:focus {\n  box-shadow: none;\n}\n\n#notifications-icon-check img.flotas-btn-notification-white {\n  filter: invert(42%) saturate(2%) brightness(200%) contrast(200%);\n}\n\n.alert-danger-form {\n  color: #db0b27;\n  background-color: #f2dede;\n  border-color: #ebccd1;\n  font-size: 0.9em;\n}\n\n.flotas-btn-error {\n  border: #db0b27;\n  border-width: 3px;\n  border-style: solid;\n}\n\n.filter-primary {\n  filter: brightness(0) saturate(100%) invert(13%) sepia(98%) saturate(4979%)\n    hue-rotate(346deg) brightness(87%) contrast(100%);\n}\n\n.alert-promocion {\n  background-color: #8bf1b6;\n  border-color: #8bf1b6;\n  min-width: fit-content;\n  padding: 1em;\n  text-align: center;\n  width: 80%;\n}\n\n.alert-incidencia {\n  color: #842029;\n  background-color: #f8d7da;\n  border-color: #f5c2c7;\n  min-width: fit-content;\n  padding: 1em;\n  text-align: center;\n  width: 80%;\n}\n\n.alert-repostaje {\n  color: #055160;\n  background-color: #cff4fc;\n  border-color: #b6effb;\n  min-width: fit-content;\n  padding: 1em;\n  text-align: center;\n  width: 80%;\n}\n\n.alert-credito {\n  color: #084298;\n  background-color: #cfe2ff;\n  border-color: #b6d4fe;\n  min-width: fit-content;\n  padding: 1em;\n  text-align: center;\n  width: 80%;\n}\n\n.alert-antifraude {\n  color: #664d03;\n  background-color: #fff3cd;\n  border-color: #ffecb5;\n  min-width: fit-content;\n  padding: 1em;\n  text-align: center;\n  width: 80%;\n}\n\n.flotas-selection > .dropdown-menu {\n  background-color: #ececec;\n  border: none;\n  text-align: left;\n  width: 100%;\n  top: 90% !important;\n}\n\n.flotas-selection > .dropdown-menu a {\n  font-weight: 700;\n  padding-bottom: 0.5em;\n  padding-top: 0.5em;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.no-flota {\n  text-align: center;\n}\n\n.no-flota h2 {\n  margin-top: 5vh;\n}\n\n#buscadorFlotas::placeholder {\n  color: #2b363b80;\n  font-weight: 600;\n}\n\n#buscadorFlotas {\n  padding: 0 1em;\n}\n\n#switch-km {\n  border-radius: 2em;\n  font-size: 1em;\n}\n\n#switch-km:hover {\n  cursor: pointer;\n}\n\ndiv.switch-km.form-check.form-switch\n  > .form-check-input[type=\"checkbox\"]:checked {\n  background-color: #db0b27;\n}\n\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28218, 13, 41, 0.25%29%27/%3e%3c/svg%3e\");\n}\n\n.form-switch .form-check-input:checked {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 1%29%27/%3e%3c/svg%3e\");\n}\n\n.flotas-registro-nueva .btn-flota-registro-tipo.btn-lg {\n  background-color: #ececec;\n  border: none;\n  border-radius: 17px;\n  box-shadow: 3px 4px 10px rgb(0 0 0 / 30%);\n  color: #2b363b;\n  font-size: 1.6em;\n  font-weight: 700;\n  margin-bottom: 2vh;\n  padding: 2.5em 2em;\n  width: 100%;\n}\n\nh1.flotas-registro {\n  font-size: 1.4em;\n  font-weight: 700;\n}\n\nh1.flotas-registro.centered {\n  text-align: center;\n}\n\n.btn-primary:disabled,\n.btn-primary.disabled {\n  background-color: transparent;\n  border-color: #2b363b40;\n  color: #2b363b40;\n}\n\n.flotas-registro-buttons {\n  display: inline-flex;\n  justify-content: space-between;\n}\n\n.flotas-registro-buttons button {\n  margin: 0 0.3em;\n  width: inherit;\n}\n\ninput.flotas-input {\n  font-size: 1.7em;\n  font-weight: 700;\n  min-height: 2em;\n  padding: 0;\n  text-align: center;\n}\n\ninput.flotas-input:focus {\n  background-color: #ececec;\n  min-height: 2em;\n  padding: 0;\n}\n\np.flotas-registro-moneda {\n  font-size: 1.4em;\n  margin-top: 1.4em;\n  text-align: center;\n}\n\n.flotas-pref-tel > .dropdown-toggle::after {\n  content: \"\" !important;\n  font-size: 1em;\n  transform: rotate(180deg);\n}\n\n.btn-flotas-tel {\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  line-height: 1.25;\n  padding: 1rem 0.75rem;\n}\n\n.flotas-pref-tel.flotas-pref-tel-ES > .dropdown-toggle::before {\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/es.svg);\n  background-size: 1.5em 1.5em;\n  display: inline-block;\n  background-repeat: no-repeat;\n  width: 2em;\n  height: 1.5em;\n  content: \"\";\n  vertical-align: bottom;\n}\n\n.flotas-pref-tel.flotas-pref-tel-PT > .dropdown-toggle::before {\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/pt.svg);\n  background-size: 1.5em 1.5em;\n  display: inline-block;\n  background-repeat: no-repeat;\n  width: 2em;\n  height: 1.5em;\n  content: \"\";\n  vertical-align: bottom;\n}\n\n.flotas-pref-tel.flotas-pref-tel-AR > .dropdown-toggle::before {\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/ar.svg);\n  background-size: 1.5em 1.5em;\n  display: inline-block;\n  background-repeat: no-repeat;\n  width: 2em;\n  height: 1.5em;\n  content: \"\";\n  vertical-align: bottom;\n}\n\n.flotas-pref-tel.flotas-pref-tel-MX > .dropdown-toggle::before {\n  background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/4.1.4/flags/4x3/mx.svg);\n  background-size: 1.5em 1.5em;\n  display: inline-block;\n  background-repeat: no-repeat;\n  width: 2em;\n  height: 1.5em;\n  content: \"\";\n  vertical-align: bottom;\n}\n\n.flotas-pref-tel > .dropdown-menu.show {\n  border: 2px solid #f5c2c7;\n  border-radius: 0.8em;\n  margin-bottom: 0.7em;\n  padding: 1em;\n  width: 14em;\n}\n\n.flotas-pref-tel > .dropdown-menu.show > a {\n  font-size: 1.1em;\n  font-weight: 600;\n  padding: 0.4em 1.5em 0.4em 0.3em;\n}\n\n.flotas-pref-tel > .dropdown-menu.show > a > img {\n  height: 1.8em !important;\n  margin-right: 1em;\n  width: 1.8em !important;\n}\n\n.back-btn-tarjeta {\n  margin-left: 10%;\n  width: 83%;\n}\n\n.flotas-warning-icon,\n.flotas-pdf-icon,\n.flotas-study-icon {\n  border-radius: 10px;\n  display: block;\n  height: 80px;\n  padding: 1.5em 1em;\n  text-align: center;\n  width: 80px;\n}\n\n.flotas-warning-icon {\n  background-color: #ececec;\n}\n\n.flotas-pdf-icon {\n  background-color: #db0b27;\n}\n\n.flotas-study-icon {\n  padding: 0.5em;\n}\n\n.flotas-model-download {\n  align-items: center;\n  display: flex;\n}\n\n.flotas-model-download p {\n  margin-left: 0.8em;\n}\n\n.flotas-status-process {\n  color: #ffc107;\n  font-weight: 700;\n}\n\n.flotas-status {\n  align-items: center;\n  display: flex;\n}\n\n.flotas-status img {\n  max-width: 60px;\n}\n\n.flotas-study {\n  max-width: 25em;\n  text-align: center;\n  margin: 0 auto;\n}\n\nh3.flotas-study {\n  font-weight: 700;\n}\n\np.flotas-study {\n  color: #2b363b80;\n  font-weight: 400;\n}\n\n#upload-document {\n  opacity: 0;\n  position: absolute;\n  width: 20%;\n  z-index: -1;\n}\n\n.flotas-document-btn {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.modal-80w {\n  max-width: 80vw;\n}\n\n.row-no-padding {\n  padding: 0;\n  margin-left: 0;\n}\n\n.flotas-info-tipo-cuenta {\n  font-size: 1.2em !important;\n  font-weight: 900 !important;\n  display: block;\n  text-transform: capitalize;\n}\n\n.flotas-info-tags {\n  display: flex;\n  overflow-x: scroll;\n  width: max-content;\n}\n\n.flotas-info-tags > .alert.alert-danger {\n  text-align: left;\n  max-width: 15em;\n  min-width: 8.2em;\n  padding: 0.3em 2em 0.3em 1em;\n  background-color: #ececec;\n  border: none;\n  color: #2b363b;\n  margin-right: 0.6em;\n  max-height: 4.1em;\n  margin-bottom: 0;\n}\n\n.flotas-info-tag-title {\n  display: block;\n  font-size: 1em !important;\n  font-weight: 700 !important;\n  margin-bottom: -0.5em;\n  color: #2b363bbf;\n}\n\n.flotas-info-tag-number {\n  font-size: 1.3em !important;\n  font-weight: 900 !important;\n}\n\n.flota-bloqueada {\n  max-width: 35em;\n  text-align: left;\n  display: inline-flex;\n  vertical-align: middle;\n  font-weight: 700;\n  font-size: 0.8em;\n  background: #da0d2926;\n  padding: 0.6em 1em;\n  border-radius: 0.5em;\n  color: #da0d29;\n  margin-top: 1em;\n}\n\n.flota-bloqueada-icon {\n  margin-right: 2em;\n  width: 30px;\n  height: 31px;\n}\n\n.thin {\n  font-weight: 300 !important;\n}\n\n.btn-icon-font {\n  color: #606676;\n}\n\n.btn-icon-font:hover {\n  color: #1d253c;\n}\n\n.flotas-actions-btn-trash {\n  font-size: 0.9em;\n}\n\n.btn-outline-grey .flotas-actions-btn-trash {\n  background-color: transparent;\n  border-color: #2b363b40;\n  color: #2b363b40;\n}\n\n.btn-outline-file {\n  background-color: transparent;\n  border-color: #2b363b40;\n  color: #2b363b40;\n}\n\n.btn-outline-file:disabled,\n.btn-outline-file.disabled {\n  background-color: transparent;\n  border-color: #2b363b40;\n  color: #2b363b;\n  font-weight: 600;\n  font-size: 0.9em;\n  text-align: left;\n  padding-left: 1em;\n}\n\n.btn-outline-primary-file,\n.outline-primary-file {\n  background-color: transparent;\n  border: none;\n  padding-left: 0.5em;\n  text-align: left;\n  display: flex;\n  align-items: end;\n  color: #db0b27;\n  font-weight: 600;\n}\n\n.btn-outline-primary-file:hover,\n.outline-primary-file:hover {\n  background-color: #eaeaea;\n  border: none;\n  color: #db0b27;\n}\n\n.form-label.flotas-form-label {\n  font-weight: 700;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 100%;\n  font-size: 0.85em;\n}\n\n.input-radio-flotas {\n  display: flex;\n  flex-direction: row;\n  align-items: end;\n  gap: 0.8em;\n  margin-left: 2em;\n}\n\n.input-radio-flotas > .form-check-input {\n  border-radius: 50%;\n  border-width: 1px;\n  border-color: #2b363b40;\n}\n\n.input-radio-flotas > .form-check-input:checked {\n  border-color: #db0b27;\n  background-image: radial-gradient(\n    circle at center,\n    #db0b27 60%,\n    transparent 61%\n  );\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 75% 75%;\n  background-color: #fff;\n  font-size: 1em;\n  line-height: 1em;\n}\n\n.input-radio-flotas > .form-check-input:checked:after {\n  content: \"\" !important;\n}\n\n.input-radio-flotas > .form-check-input:checked + label {\n  color: #db0b27;\n  font-weight: 600;\n}\n\n/* BREAKPOINT TABLETS*/\n@media (min-width: 768px) {\n}\n\n/* BREAKPOINT ESCRITORIO */\n@media (min-width: 992px) {\n  /* General Styles */\n  .flotas-register-btn {\n    width: fit-content;\n    margin: 0 auto;\n    padding-left: 2em;\n    padding-right: 2em;\n  }\n\n  .flotas-btn-step1 {\n    display: flex;\n  }\n\n  .flotas-registro-nueva .btn-flota-registro-tipo.btn-lg {\n    margin: 0 0.5em;\n  }\n\n  .flotas-registro-cantidad {\n    display: flex;\n    justify-content: space-evenly;\n    margin: 0 auto;\n    width: 60%;\n  }\n\n  .flotas-registro-cantidad input.flotas-input {\n    width: 40%;\n  }\n\n  .flotas-status {\n    margin: 0 auto;\n    text-align: center;\n  }\n\n  .flotas-image-info {\n    width: 60%;\n    margin: 0 auto;\n  }\n\n  .flotas-document-btn {\n    display: block;\n    font-size: 1em;\n  }\n\n  label.flotas-document-btn {\n    padding-top: 0.8em;\n  }\n\n  .no-flota {\n    margin-top: -5em;\n  }\n\n  .back-btn-tarjeta {\n    width: 25%;\n  }\n\n  .flotas-model-download {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .flotas-pdf-icon {\n    width: 60px;\n    height: 60px;\n    padding: 0.8em;\n  }\n\n  .flotas-info-tags {\n    display: inline-flex !important;\n    width: fit-content;\n    overflow: hidden;\n  }\n\n  .flotas-info {\n    position: absolute;\n    top: 0;\n    width: fit-content;\n  }\n\n  .flota-bloqueada {\n    margin: 0 1em;\n  }\n\n  .flota-bloqueada-icon {\n    margin-right: 1em;\n  }\n\n  .flotas-selection {\n    display: inline;\n  }\n\n  .flotas-selection .dropdown-toggle::after,\n  .flotas-saldo .dropdown-toggle::after {\n    position: inherit;\n  }\n\n  .flotas-selection .dropdown-toggle,\n  .flotas-saldo .dropdown-toggle {\n    width: fit-content;\n    text-align: center;\n  }\n\n  .flotas-selection > .dropdown-menu {\n    text-align: center;\n    width: 100%;\n    top: -20% !important;\n    max-height: 200px;\n    overflow-y: auto;\n  }\n\n  /* .flotas-info-tags > .alert.alert-danger {\n    max-width: 10em;\n  } */\n\n  .flotas-info-tag-title {\n    display: block;\n    font-size: 0.7em !important;\n    font-weight: 700 !important;\n    margin-bottom: inherit;\n  }\n\n  .flotas-info-tag-number {\n    font-size: 1em !important;\n    font-weight: 900 !important;\n  }\n\n  .flotas-info-tipo-cuenta {\n    margin-top: inherit;\n  }\n\n  table.flotas thead {\n    border-bottom: 1px solid #dbdbdb;\n  }\n\n  table.flotas tr,\n  table.flotas td {\n    border-bottom: none;\n  }\n  table.flotas th,\n  table.flotas th:last-child,\n  table.flotas td {\n    text-align: left;\n  }\n\n  table.flotas th,\n  table.flotas td {\n    display: table-cell !important;\n  }\n\n  .no-pointer {\n    cursor: not-allowed;\n    pointer-events: none;\n  }\n\n  .flotas-btn-add {\n    max-width: 94%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
